module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kb-article"
  }, [_c('div', {
    staticClass: "panel h1-panel"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h1', [_c('router-link', {
    attrs: {
      "to": "/kb"
    }
  }, [_vm._v("Knowledge Base")])], 1)]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('section', {
    staticClass: "panel article-panel"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [(_vm.article) ? _c('div', {
    staticClass: "article"
  }, [_c('div', {
    staticClass: "article-heading"
  }, [(_vm.getCoverImageUrl(_vm.article)) ? _c('img', {
    attrs: {
      "src": _vm.getCoverImageUrl(_vm.article)
    }
  }) : _c('img', {
    attrs: {
      "src": require("../assets/img/ttto-thumbnail.jpg")
    }
  }), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.article.title))]), _vm._v(" "), _c('div', [_c('span', [_vm._v("Edited " + _vm._s(_vm.getLastEditTimeFromNow()))]), _vm._v(" "), (_vm.canEdit) ? _c('router-link', {
    attrs: {
      "to": _vm.getArticleEditorLocation()
    }
  }, [_vm._v("\n                            Edit\n                        ")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    ref: "article-body",
    staticClass: "article-body",
    domProps: {
      "innerHTML": _vm._s(_vm.article.body)
    }
  }), _vm._v(" "), (_vm.showExtras) ? _c('div', [_c('hr'), _vm._v(" "), _c('div', {
    staticClass: "article-extras"
  }, [(_vm.article.categories.length > 0) ? _c('div', {
    staticClass: "info-group"
  }, [_c('div', {
    staticClass: "info-group-label"
  }, [_vm._v("Categories")]), _vm._v(" "), _c('option-list', {
    attrs: {
      "value": _vm.linkedCategories
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.article.termTypes.length > 0) ? _c('div', {
    staticClass: "info-group"
  }, [_c('div', {
    staticClass: "info-group-label"
  }, [_vm._v("Term Types")]), _vm._v(" "), _c('option-list', {
    attrs: {
      "value": _vm.linkedTermTypes
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.article.paths.length > 0) ? _c('div', {
    staticClass: "info-group"
  }, [_c('div', {
    staticClass: "info-group-label"
  }, [_vm._v("Paths")]), _vm._v(" "), _c('option-list', {
    attrs: {
      "value": _vm.linkedPaths
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.article.software.length > 0) ? _c('div', {
    staticClass: "info-group"
  }, [_c('div', {
    staticClass: "info-group-label"
  }, [_vm._v("Software")]), _vm._v(" "), _c('software-list', {
    attrs: {
      "value": _vm.linkedSoftware
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.article.tags.length > 0) ? _c('div', {
    staticClass: "info-group"
  }, [_c('div', {
    staticClass: "info-group-label"
  }, [_vm._v("Tags")]), _vm._v(" "), _c('tag-list', {
    attrs: {
      "value": _vm.linkedTags
    }
  })], 1) : _vm._e()])]) : _vm._e()]) : _c('div', {
    staticClass: "loading-msg article-body"
  }, [_vm._v("\n                Loading...\n            ")])])]), _vm._v(" "), _c('kb-feedback')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-body"
  }, [_c('h2', [_vm._v("Article")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-39639e65!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/KbArticle.vue
// module id = 2018
// module chunks = 2